import { Box, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DashboardTabs from '../components/dashboard/DashboardTabs';
import { dashboardTabs } from '../components/dashboard/dashboardMockData';
import DocumentsWorkspace from '../components/documents/DocumentsWorkspace';

const Documents = () => {
    const navigate = useNavigate();

    const handleTabClick = (tab) => {
        if (tab === 'Início') {
            navigate('/');
            return;
        }

        if (tab === 'Agendamentos') {
            navigate('/appointments');
            return;
        }

        if (tab === 'Equipa Técnica') {
            navigate('/doctors');
            return;
        }

        if (tab === 'Cuidadores e Pacientes') {
            navigate('/caregivers');
            return;
        }

        if (tab === 'Documentos') {
            navigate('/documents');
        }
    };

    return (
        <Box
            sx={{
                px: { xs: 1.5, md: 2 },
                pb: { xs: 1.5, md: 2 },
                pt: 0,
                bgcolor: '#FFFFFF',
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                overflow: 'hidden'
            }}
        >
            <Box sx={{ mt: 0 }}>
                <DashboardTabs tabs={dashboardTabs} onTabClick={handleTabClick} activeTab="Documentos" />
            </Box>

            <Paper
                variant="elevation=0"
                sx={{
                    p: { xs: 1.8, md: 2.2 },
                    bgcolor: '#FFFFFF',
                    borderRadius: '20px',
                    boxShadow: 'none',
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden'
                }}
            >
                <DocumentsWorkspace />
            </Paper>
        </Box>
    );
};

export default Documents;


